/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Dmitri Puscas
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { EventTransport } from "./EventTransport";
import { EventType } from "./EventType";

export interface NotificationCustomer {
  id: number;
  subject: string;
  content?: string;
  customerId?: number;  
  createdAt?: Date;
  eventTransport: EventTransport;
  eventType: EventType;
}
